import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)
const state ={
    login:false,
    routerAss:false,
}

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/page/store/index.js